module.exports = __webpack_public_path__ + "img/2.139fd8ef.png";